<template>
  <div
    class="text-left text-light-950 bg-white rounded-xl relative flex flex-col border-2 border-b-4 border-charcoal-950/5 overflow-hidden"
    :style="theme ? {
      color: theme.base.text.base,
      borderColor: theme.base.background.borderWeak,
      backgroundColor: theme.base.background.base,
    } : {}"
  >
    <div class="rounded-t-[0.6rem] relative overflow-hidden bg-white p-3 text-right" :class="[ user?.['@profile']?.banner ? 'h-16' : '']" :style="theme ? { background: theme.base.background.weak } : {}">
      <img
        :src="user?.['@profile']?.banner"
        class="absolute w-full h-full scale-[1.025] top-0 left-0 object-cover"
        draggable="false"
        loading="lazy"
        v-if="user?.['@profile']?.banner"
      >
    </div>
    <div class="px-3.5 pb-2.5 -mt-7 grow flex flex-col">
      <div class="flex items-center -ml-0.5">
        <UserPicture :user="user" :theme="theme" size="md" class="shrink-0 relative z-30" />

        <div class="relative grow z-30 pl-3 pt-8">
          <p class="font-bold text-lg line-clamp-1 break-all">
            {{ user.name }}

            <span class="text-sm font-medium ml-0.5" :style="{ color: theme.base.text.weak }">{{ user.pronouns.join(' / ') }}</span>
          </p>
        </div>
      </div>

      <div class="font-medium leading-snug mt-2" v-if="user['@profile']?.bio">
        {{ stripTags(user['@profile'].bio) }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { User } from '@/classes'
import UserStore from '@/store/user'
import { THEMES_DARK } from '@/static/themes'

const props = withDefaults(defineProps<{
  user: User
  theme?: keyof typeof THEMES_DARK | null
}>(), {
  isTheme: true,
  theme: null
})

const userStore = UserStore()
const { colorTheme } = storeToRefs(userStore)

const theme = computed(() => THEMES_DARK[props.theme ?? props.user.theme][colorTheme.value])
</script>